import Skeleton from '~/components/Loading/Skeleton';

/** List / table pending skeleton (projects, queues, documents). */
export function ListPageSkeleton() {
  return (
    <div className="flex h-full min-h-full w-full flex-col gap-4 p-4" aria-busy="true" aria-label="Loading list">
      <div className="flex items-center justify-between gap-4">
        <Skeleton className="h-7 w-44" />
        <Skeleton className="h-8 w-24" />
      </div>
      <Skeleton className="h-9 w-full max-w-sm" />
      <div className="space-y-2">
        {[...Array(8)].map((_, i) => (
          <Skeleton key={i} className="h-11 w-full" />
        ))}
      </div>
    </div>
  );
}
